/**
 * A single labeled setting row: label + optional description on the left,
 * control on the right. Used uniformly across all settings sections so
 * every preference looks consistent.
 */

.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 12px 0;
  border-bottom: 1px solid #2d2d2d;
}

.row:last-child {
  border-bottom: none;
}

.label-group {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.label {
  font-size: 14px;
  font-weight: 500;
  color: #e5e7eb;
  line-height: 1.4;
}

.description {
  font-size: 12px;
  color: #9ca3af;
  line-height: 1.4;
}

.control {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 10px;
}
